export default "__VITE_ASSET__DdOGKxb1__";